import { Entity } from '@app/core';
import { IParameter, IParameterField, IParameterModule } from '@games/interfaces';

export class ParameterField extends Entity<IParameterField> {
  constructor(props: IParameterField) {
    super(props);
  }

  get name(): string {
    return this.props.name;
  }

  get code(): string {
    return this.props.fieldName;
  }

  get description(): string {
    return this.props.description;
  }

  get value(): number {
    return this.props.value;
  }

  get previousValue(): number {
    return this.props.previousValue;
  }

  get possibleValues(): number {
    return this.props.dropdown;
  }

  get precis(): number {
    return this.props.precis;
  }

  get visible(): boolean {
    return !!this.props.visible;
  }

  get min(): number {
    return this.props.min;
  }

  get max(): number {
    return this.props.max;
  }
}

export class ParameterModule extends Entity<IParameterModule> {
  constructor(props: IParameterModule) {
    super(props);
  }

  get name(): string {
    return this.props.moduleName;
  }

  get description(): string {
    return this.props.description;
  }

  get fields(): ParameterField[] {
    return (
      this.props.fields &&
      this.props.fields
        .map((field: IParameterField) => new ParameterField(field))
        .filter((field: ParameterField) => field.visible)
    );
  }
}

export class Parameter extends Entity<IParameter> {
  constructor(props: IParameter) {
    super(props);
  }

  get category(): string {
    return this.props.category;
  }

  get modules(): ParameterModule[] {
    return (
      this.props.modules &&
      this.props.modules
        .map((module: IParameterModule) => new ParameterModule(module))
        .filter((module: ParameterModule) => module.fields.length)
    );
  }
}
